import { ModalErrorDocumentValidationConfig } from '@core/interfaces/modal-error-config.interface';
import { PROJECT_TYPE } from '@core/types/projects.type';

export const DocumentResponse = {
  validated: '0',
  notValidated: '1',
  frontSuccess: '8020001012',
  allSuccess: '8020001041',
  dniExpired: '8020001004',
};

export const DOCUMENT_VALIDATION_CONFIG = new Map<string, ModalErrorDocumentValidationConfig>([
  [
    'general',
    {
      imageUrl: {
        url: 'assets/img/errors/error__document_identification.svg',
        altUrl: '',
      },
      errorTitle: 'Validación fallida',
      errorDescription:
        'Lo sentimos, no pudimos validar tu documento. <br> Por favor, vuelve a intentarlo.',
      errorDescriptionMobile:
        'Lo sentimos, no pudimos<br> validar tu documento.  Por favor, <br> vuelve a intentarlo.',
      buttonLabel: 'Reintentar',
    },
  ],
  [
    'dniExpired',
    {
      imageUrl: {
        url: 'assets/img/errors/error__document_identification.svg',
        altUrl: '',
      },
      errorTitle: 'Validación fallida',
      errorDescription:
        'No te podemos validar, por favor asegúrate de tener tu <br> documento vigente.',
      errorDescriptionMobile:
        'No te podemos validar, por favor <br> asegúrate de tener tu <br> documento vigente.',
      buttonLabel: 'Reintentar',
    },
  ],
]);
